import { Controller } from "stimulus"
import EasyMDE from "easymde"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.editor = new EasyMDE({
      element: this.inputTarget
    })


    this.isUserEditing = false
    this.lastUpdateTime = null
    this.editor.codemirror.on("change", () => {
      this.isUserEditing = true
      this.lastUpdateTime = Date.now()
  
      clearTimeout(this.editingTimeout)
      this.editingTimeout = setTimeout(() => {
        this.isUserEditing = false
      }, 2000)
    })

    const handleFullscreenChange = () => {
      if (this.editor.isFullscreenActive()) {
        document.getElementById("app-top").style.display = "none"
        document.querySelector(".app-nav").style.display = "none"
      } else {
        document.getElementById("app-top").style.display = ""
        document.querySelector(".app-nav").style.display = ""
      }
    }
    // 1. Toolbar button click
    let fullscreenButton = document.querySelector(".fullscreen.no-disable.no-mobile")
    if (fullscreenButton) {
      fullscreenButton.addEventListener("click", handleFullscreenChange)
    }

    // 2. ESC key (CodeMirror listens for it)
    this.editor.codemirror.on("refresh", handleFullscreenChange)
  
    const generative = this.inputTarget.dataset.generative === "true"
    const content = (this.inputTarget.value || "").trim()

    if (generative && content.length > 0) {
      // this.editor.value("")
      this.editor.value(content)
    } else if (content.length > 0) {
      this.editor.value(content)
    }
  }

  disconnect() {
    if (this.editingTimeout) {
      clearTimeout(this.editingTimeout)
    }
  }

  startTypingAnimation(text) {
    let index = 0
    const interval = setInterval(() => {
      if (index < text.length) {
        this.editor.value(this.editor.value() + text.charAt(index))
        this.scrollToBottom()
        index++
      } else {
        clearInterval(interval)
        setTimeout(() => this.smoothScrollToTop(), 1000)
      }
    }, 20)
  }

  scrollToBottom() {
    const cm = this.editor.codemirror
    cm.scrollTo(null, cm.getScrollInfo().height)
  }

  smoothScrollToTop() {
    const cm = this.editor.codemirror
    const startY = cm.getScrollInfo().top
    const duration = 1000
    const startTime = performance.now()

    const animate = (time) => {
      const elapsed = time - startTime
      const progress = Math.min(elapsed / duration, 1)
      const ease = 1 - Math.pow(1 - progress, 3)
      const newY = startY * (1 - ease)

      cm.scrollTo(null, newY)

      if (progress < 1) {
        requestAnimationFrame(animate)
      }
    }

    requestAnimationFrame(animate)
  }
}
